import { createRequest, getError } from "Utils/requestUtils";
import { call, put, takeLatest } from "redux-saga/effects";
import { Breed, OperationType } from "./findAnimalBreedInterfaces";
import {
  findAnimalBreedStart,
  findAnimalBreedSucceeded,
  operationFailed,
} from "./findAnimalBreedSlice";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* findAnimalBreed({
  payload,
}: ReturnType<typeof findAnimalBreedStart>) {
  const species = payload.species.toUpperCase();

  try {
    const finalEndpointUrl = `/open/insurance/registry/animal/${species}`;

    const { data } = yield call(createRequest, {
      method: "get",
      url: finalEndpointUrl,
    });

    yield put(findAnimalBreedSucceeded(Object.values(data)[0] as Breed[]));
  } catch (error) {
    yield put(
      operationFailed({
        operationType: OperationType.FIND_ANIMAL_BREED,
        response: getError(error),
      }),
    );
  }
}

export function* findAnimalBreedSaga(): Generator {
  yield takeLatest(findAnimalBreedStart, findAnimalBreed);
}
